import React, { useEffect } from 'react';
import { Header } from './components/Header';
import { Hero } from './components/Hero';
import { ServiceLines } from './components/ServiceLines';
import { ClientSuccessStories } from './components/ClientSuccessStories';
import { Leadership } from './components/Leadership';
import { Testimonial } from './components/Testimonial';
import { Footer } from './components/Footer';
export function App() {
  useEffect(() => {
    document.title = 'Think Act: Strategy to Impact';
  }, []);
  return <div className="w-full min-h-screen" data-id="element-0">
      <Header data-id="element-1" />
      <main data-id="element-2">
        <Hero data-id="element-3" />
        <ServiceLines data-id="element-4" />
        <ClientSuccessStories data-id="element-5" />
        <Leadership data-id="element-6" />
        <Testimonial data-id="element-7" />
      </main>
      <Footer data-id="element-8" />
    </div>;
}